export const faqReconciliation = [
  {
    title : "faq_recon_title_1",
    description: "faq_recon_description_1"
  },
  {
    title : "faq_recon_title_2",
    description: "faq_recon_description_2"
  },
  {
    title : "faq_recon_title_3",
    description: "faq_recon_description_3"
  },
  {
    title : "faq_recon_title_4",
    description: "faq_recon_description_4"
  },
  {
    title : "faq_recon_title_5",
    description: "faq_recon_description_5"
  },
  {
    title : "faq_recon_title_6",
    description: "faq_recon_description_6"
  },
  {
    title : "faq_recon_title_7",
    description: "faq_recon_description_7"
  }
]